import './fontCss/video.css'
import {Component, createRef} from "react";
import RxPlayer from "rx-player/minimal";
import {getLiveKeySystems} from "../globalMethods/webservice";
import {DASH, DIRECTFILE, EME} from "rx-player/features";
import TimerFullScreen from "../globalMethods/timerFullScreen";
import SeekSlider from "./seekslider/slider";
import {valideLogin} from "../login/UserService";
import {isSafari} from "../globalMethods/utils";
import {getSavedBarcode} from "../globalMethods/myConfig";
RxPlayer.addFeatures([DASH, EME, DIRECTFILE]);
export class RunnerPlayer extends Component {


    constructor(props) {
        super(props)
        this.state = {
            channels: [],
            paramsEpgId: props?.paramsEpgId,
            player: {},
            mpdUrl: props?.mpdUrl,
            userProfile: props?.userProfile,
            configuration: props?.config,
            programmStart:"09:30",
            programmEnd:"12:30",
            value:30,
            showVolume:false,
            events: props?.events,
            eventsProgress: 0,
            logoUrl:"",
            programmTitle:"",
            programmSubTitle:"",
            showBarMenu: true,
            counter: 0,
            cursor: "pointer",
            showDrawer: props?.showDrawer,
            setShowDrawer: props.setShowDrawer,
            channelLogo : props?.channelLogo,
            userCode : getSavedBarcode(),
        }
        this.myVideoElementRef = createRef();
        this.player = null
        this.handleClose = props.handleClose;

    }

    componentWillUnmount() {
        // 3. Clean up: Dispose of the RxPlayer instance when the component unmounts
        // This prevents the error "The video element is already attached to another RxPlayer instance."
        if (this.player) {
            try {
                this.player?.dispose();
                this.player = null; // Clear the reference
            }
            catch (e) {
            }

        }
    }

    componentDidMount() {
        this.initPlayer()
    }
     async initPlayer() {

         const valide = await valideLogin()
         if (!valide) {
             window.location.href = "/"
         }
         const videoElement = document.getElementById("video")

         if (videoElement) {

             if (this.player) {
                 try {
                     if(this.player?.state?.includes("LOADING")){
                         this.player?.dispose();
                     }

                 }
                 catch (e) {
                 }

             }

             this.player = new RxPlayer({videoElement: videoElement})

             this.player?.setVolume(0.1)

             this.player.addEventListener("error", (err) => {
                 console.log("the content stopped with the following error", err);
                 const error = this.player.getError();
                 if (!error) {
                     console.log("The player did not crash");
                 } else if (error.code === "PIPELINE_LOAD_ERROR") {
                     console.error("The player crashed due to a failing request");
                 } else {
                     console.error(`The player crashed: ${error.code}`);
                 }
             })

             if (this.props.mpdUrl !== "") {

                 this.player?.loadVideo({
                     url: this.props.mpdUrl,
                     transport: !isSafari()? "dash" : "directfile",
                     autoPlay: true,
                     keySystems: getLiveKeySystems(this.props.paramsEpgId, this.props.userProfile, this.props.config),
                     referenceDateTime:
                         this.props.config.referenceDateTime || Date.UTC(2013, 5, 1, 0, 0, 0, 0) / 1000,
                     checkMediaSegmentIntegrity: undefined,
                     checkManifestIntegrity: undefined,

                 })
             }


         }

     }

    render() {
        return (
            <>
                <TimerFullScreen hideControlBarAction={()=>{
                    this.setState({showBarMenu:false, cursor: "none"})
                    document.body.style.cursor = 'none';
                }}
                                 initialValue={()=> {
                                     this.setState({counter:0})
                                 }}
                                 isPlaying={this.state.player}
                                 counter={this.state.counter}
                                 isShowing={this.state.showBarMenu}
                                 handleClose={this.props.handleClose}
                                 setCounter={()=> {
                                     this.setState({counter:this.state.counter + 1})
                                 }}
                ></TimerFullScreen>




                <div
                     onMouseMove={()=>{
                         this.setState({showBarMenu:true, counter:0, cursor: "pointer"})
                         document.body.style.cursor = 'pointer';
                     }}
                     className='fullscreen-container' id="fullscreen-container">


                    <video ref={this.myVideoElementRef} id="video"></video>

                    <SeekSlider player={this.player}
                                showBarMenu={this.state.showBarMenu}
                                channelsInfo={this.state.events}
                                showTimerBarEvent={()=>{
                                    this.setState({showBarMenu:true, counter: 0})
                                }}
                                handleClose={this.handleClose}
                                chanelLogo={this.state.channelLogo}
                                userCode={this.state.userCode}
                    ></SeekSlider>

                </div>
            </>

        );
    }
}